export const getFileMimeType = (fileLongName: string) => {
  const fileExtension = fileLongName.split('.').pop();
  let mimeType = '';

  switch (fileExtension) {
    case 'doc':
      mimeType = 'application/msword';
      break;
    case 'docx':
      mimeType =
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'pdf':
      mimeType = 'application/pdf';
      break;
    case 'webm':
      mimeType = 'video/webm';
      break;
    case 'mp4':
      mimeType = 'video/mp4';
      break;
    case 'mov':
      mimeType = 'video/quicktime';
      break;
    case 'tif':
    case 'tiff':
      mimeType = 'image/tiff';
      break;
    case 'jpg':
    case 'jpeg':
    case 'jfif':
      mimeType = 'image/jpeg';
      break;
    case 'png':
      mimeType = 'image/png';
      break;
    case 'gif':
      mimeType = 'image/gif';
      break;
    case 'webp':
      mimeType = 'image/webp';
      break;
    case 'bmp':
      mimeType = 'image/bmp';
      break;
    case 'mp3':
      mimeType = 'audio/mpeg';
      break;
    case 'wav':
      mimeType = 'audio/wav';
      break;
    case 'ogg':
      mimeType = 'audio/ogg';
      break;
    default:
      break;
  }
  return mimeType;
};

export function getFileMimeCode(file: string) {
  switch (file) {
    case 'pdf':
      return 'JVBERi0';
    default:
      return '';
  }
}
